import { createSelector } from "@reduxjs/toolkit";

export const selectGame = (state: RootState) => state.moodle.game;
export const selectQuizzes = (state: RootState) => state.moodle.quizzes;
export const selectCourseBlocks = (state: RootState) =>
  state.moodle.courseBlocks;
